import { derived } from "svelte/store";
import { page } from "$app/stores";
import { routes } from "$lib/routes";

export const isRootPage = derived(page, ($page) => $page.url.pathname === routes.root);
export const isSearchPage = derived(page, ($page) => $page.url.pathname.startsWith(routes.searches));
export const isCampaignsPage = derived(page, ($page) => $page.url.pathname.startsWith(routes.campaigns));
export const isSettingsPage = derived(page, ($page) => $page.url.pathname.startsWith(routes.settings));
export const isListsPage = derived(page, ($page) => $page.url.pathname.startsWith(routes.lists));
